import { AbstractMapLayerProviderListFormModel } from 'app/overview/config/configuration_tab/general/frontend_config/common/AbstractMapLayerProviderListFormModel';
import { ImsFeatureLayerProvider } from 'app/config/ImsFeatureLayerProvider';
import { FeatureLayerProviderFormModel } from 'app/overview/config/configuration_tab/general/frontend_config/featureLayer/FeatureLayerProviderFormModel';
import { ImsFeatureLayerProviderList } from 'app/config/ImsFeatureLayerProviderList';

export class FeatureLayerProviderListFormModel extends AbstractMapLayerProviderListFormModel<
    ImsFeatureLayerProvider,
    ImsFeatureLayerProviderList,
    FeatureLayerProviderFormModel
> {
    protected createMapLayerListProviderFromValueUnderEdit(): ImsFeatureLayerProviderList {
        return new ImsFeatureLayerProviderList(
            this._providerFormModels.map((m) => m.valueUnderEdit.clone()),
        );
    }

    protected createProviderFormModel(
        origValue: ImsFeatureLayerProvider,
        valueUnderEdit: ImsFeatureLayerProvider,
    ): FeatureLayerProviderFormModel {
        return new FeatureLayerProviderFormModel(this, origValue, valueUnderEdit);
    }

    /**
     * Create a new provider, blank details
     */
    addNewProvider(): FeatureLayerProviderFormModel {
        const newFormModel = this._createProviderFormModel(null, new ImsFeatureLayerProvider(null));
        newFormModel.setExpanded(true);
        this._providerFormModels.push(newFormModel);
        this._notifyListeners();
        return newFormModel;
    }
}
